import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TikTokDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.298 11.015a11.126 11.126 0 0 1-10.914-8.933A11.03 11.03 0 0 1 30.167 0h-7.187v19.63l-.009 10.748c0 2.874-1.876 5.31-4.467 6.17a6.53 6.53 0 0 1-5.388-.594 6.487 6.487 0 0 1-3.176-5.482c-.052-3.631 2.883-6.6 6.515-6.6.715 0 1.404.12 2.05.327V16.918a13.778 13.778 0 0 0-2.075-.154 13.783 13.783 0 0 0-10.355 4.63 13.508 13.508 0 0 0-3.4 8.132 13.463 13.463 0 0 0 4.011 10.481A13.774 13.774 0 0 0 16.431 44c.697 0 1.394-.052 2.074-.155a13.753 13.753 0 0 0 7.67-3.838 13.443 13.443 0 0 0 4.036-9.57l-.034-16.057a17.808 17.808 0 0 0 4.037 2.35 18.111 18.111 0 0 0 7.1 1.428v-7.151c.01.008-.016.008-.016.008Z",
    svgColor: "#474358"
  }));
});
TikTokDark.displayName = 'TikTokDark';
TikTokDark.defaultProps = {
  'aria-label': 'TikTokDark'
};
export default TikTokDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/TikTokDark.js
// module id = 2962
// module chunks = 11